import DOMPurify from "dompurify";

type Props = {
  html: string | null | undefined;
  className?: string;
  fallback?: string;
};

const RichText = ({ html, className = "", fallback = "" }: Props) => {
  const source = (html && html.trim().length > 0 ? html : fallback) ?? "";
  if (!source) return null;
  const clean = DOMPurify.sanitize(source, {
    ALLOWED_TAGS: ["p", "br", "strong", "em", "u", "a", "ul", "ol", "li", "h2", "h3", "blockquote", "code"],
    ALLOWED_ATTR: ["href", "target", "rel"],
  });
  return (
    <div
      className={`prose-richtext ${className}`}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
};

export default RichText;
